import * as React from 'react'

import { formatDateTime } from '@app/lib/time'

interface Props {
  className?: string
  dateTime?: Date
}

const VisitDateTime = function ({ className, dateTime }: Props) {
  return <span className={className}>{formatDateTime(dateTime)}</span>
}

export default VisitDateTime
